var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCarretGreen({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.70508 0.0307086C3.64492 0.0494586 3.55742 0.0799274 3.51367 0.0986774C3.38242 0.157271 3.18555 0.354146 3.12813 0.480709C3.07617 0.595552 3.07617 0.731489 3.07617 6.00024C3.07617 11.2784 3.07617 11.4049 3.12813 11.5198C3.19922 11.6745 3.40977 11.8643 3.59023 11.9323C3.69688 11.9745 3.78438 11.9862 3.9375 11.9885C4.34492 11.9885 4.08789 12.1877 7.6207 9.15727C11.1535 6.12915 10.9238 6.34946 10.9238 6.00024C10.9238 5.65102 11.1535 5.87133 7.6207 2.84321C4.78516 0.412739 4.4543 0.136177 4.30938 0.0799274C4.1207 0.0072711 3.86641 -0.0138227 3.70508 0.0307086Z",
    fill: "#247A3D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarretGreen);
export default __webpack_public_path__ + "static/media/carret-green.2e4c0d2e4f465e5733aa50285ed9e7b4.svg";
export { ForwardRef as ReactComponent };